import React from 'react';
import { createFileRoute } from '@tanstack/react-router'


import { Box } from '@mui/material';
import Raindrops from '../components/effects/Raindrops';
// import Bubbles from '../components/effects/BlobLoader';
import BlurText from '../components/effects/BlurText';
import Sun from '../components/effects/Sun';
import logoUrl from '../assets/floodnet_logo_bw_5in.png'

export const Route = createFileRoute('/weather/{-$condition}')({
  component: LoadingPage,
})


const Container = ({ children, sx }) => {
    return (
        <Box sx={{
            display: 'flex',
            justifyContent: 'stretch',
            alignItems: 'stretch',
            height: '100vh !important',
            width: '100vw !important',
            // background: 'linear-gradient(165deg, black, #3a426f70)',
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 0,
            ...sx,
            // backgroundImage: 'linear-gradient(135deg, #ffffff75, #ffbd7157), linear-gradient(30deg, #ffffff00, #16d7ffde)',
        }}>
            {children}
        </Box>
    )
}

function LoadingPage({ children }) {
    // condition='rain', 
    const { condition='rain' } = Route.useParams()
    const isDark = window.matchMedia?.('(prefers-color-scheme: dark)')?.matches;
    const bgFor = (light: string, dark: string) => (isDark ? dark : light);
    return (
        <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100vw',
            height: '100vh',
            position: 'relative',
            // zIndex: 100000,
            
        }}>
            {/* <CircularProgress /> */}
            {/* <Box sx={{
                display: 'flex',
                justifyContent: 'stretch',
                alignItems: 'stretch',
                height: '100vh !important',
                width: '100vw !important',
                // background: 'linear-gradient(165deg, black, #3a426f70)',
                position: 'absolute',
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: -1,
                // filter: 'blur(30px)',
            }}>
                <Bubbles />
            </Box> */}
            {condition === 'sun' ? (
                <Container sx={{backgroundImage: bgFor('linear-gradient(135deg, #ffffff75, #ffbd7157), linear-gradient(30deg, #ffffff00, #16d7ffde)', 'linear-gradient(135deg, #1f2a38, #15202f), linear-gradient(30deg, #0b111c, #0f1d2f)')}}>
                    <Sun />
                </Container>
            ) : condition === 'rain' ? (
                <Container sx={{backgroundImage: bgFor('linear-gradient(135deg, #ffffff, #dae4ff)', 'linear-gradient(135deg, #0f172a, #1f2a44)')}}>
                    <Raindrops />
                </Container>
            ) : condition === 'heavy-rain' ? (
                <Container sx={{backgroundImage: bgFor('linear-gradient(135deg, #ffffff, #aec5ff)', 'linear-gradient(135deg, #0e1624, #23345c)')}}>
                    <Raindrops 
                        nDrops={64} 
                        duration={2} 
                        rainAngle='25deg' 
                        dropletWidth='4px'
                        nRipples={1} 
                        nParticles={2} />
                </Container>
            ) : condition === 'downpour' ? (
                // linear-gradient(135deg, #e5e5e5, #3d5eb2e3)
                (<Container sx={{backgroundImage: bgFor('linear-gradient(to bottom right, rgb(221, 221, 221), rgb(195, 195, 195))', 'linear-gradient(135deg, #0c111b, #1b2b3e)')}}>
                    <Raindrops 
                        nDrops={64} 
                        duration={1.4} 
                        rainAngle='45deg' 
                        groundAngle='80deg' 
                        dropletWidth='4px'
                        nRipples={1} 
                        nParticles={1} />
                </Container>)
            ) : condition === 'light-rain' ? (
                <Container sx={{backgroundImage: bgFor('linear-gradient(135deg, #ffffff, #d4eeff)', 'linear-gradient(135deg, #0f172a, #1c2b3f)')}}>
                    <Raindrops 
                        nDrops={6} 
                        rainAngle='2deg' 
                        nRipples={2} 
                        nParticles={5}
                        rippleSpacing={0.05}
                        />
                </Container>
            ) : condition === 'sunny-rain' ? (
                <Container sx={{backgroundImage: bgFor('linear-gradient(135deg, #ffffff75, #ffbd7157), linear-gradient(30deg, #ffffff00, #16d7ffde), linear-gradient(135deg, #ffffff, #aec5ff)', 'linear-gradient(135deg, rgba(255,255,255,0.05), rgba(255,196,112,0.08)), linear-gradient(30deg, rgba(255,255,255,0), rgba(22,215,255,0.15)), linear-gradient(135deg, #0f172a, #1e2d44)')}}>
                    <Sun />
                    <Raindrops 
                        nDrops={18} 
                        nRipples={2} 
                        rainAngle='0deg' 
                        rippleSpacing={0.06}
                        duration={3.4} />
                </Container>
            ) : null}
            <Box display='flex' flexDirection='column' gap={1} alignItems='center' py={4} sx={{ zIndex: 1, width: '100%', height: '100%' }}>
                <img src={logoUrl} alt="Floodnet Logo" style={{ 
                  maxWidth: '300px', 
                  // filter: 'brightness(0)' 
                  }} />
                <BlurText text="Floodnet" fontSize='5em' />
                <Box display='flex' flexDirection='column' alignItems='center' flexShrink={1} sx={{ overflow: 'auto', width: '100%' }}>
                    {children}
                </Box>
            </Box>
        </Box>
    )
}

export default LoadingPage;
